import React from 'react';
import { Camera, Clock, MessageSquare, Truck } from 'lucide-react';
import { business } from '../data/business';
const reasons = [{
  icon: MessageSquare,
  title: 'You text a person, not a call center',
  body: 'Mason answers his own phone. No dispatcher, no upsell script, no waiting three days for a callback.'
}, {
  icon: Clock,
  title: 'On time, or you hear from us first',
  body: 'You get a text when the truck is on the way and a heads up the moment anything changes.'
}, {
  icon: Camera,
  title: 'Photo proof before we pull away',
  body: 'Every gutter run and every washed surface gets documented so you can see exactly what you paid for.'
}, {
  icon: Truck,
  title: 'One truck for the whole exterior',
  body: 'Glass, gutters and concrete handled in a single visit instead of three different companies.'
}];
const steps = [{
  step: '1',
  title: 'Call or text',
  body: `Send your address and what needs cleaning to ${business.phone}.`
}, {
  step: '2',
  title: 'Get a flat price',
  body: 'Most estimates come back the same day. No pressure, no hidden fees.'
}, {
  step: '3',
  title: 'Pick your day',
  body: 'We work around your schedule, evenings and Saturdays included.'
}, {
  step: '4',
  title: 'See the difference',
  body: 'We clean up, send photos, and you only pay when you are happy.'
}];
export function WhyUs() {
  return <section id="why-us" className="w-full bg-brand-sky py-16 lg:py-24" data-id="element-219" data-mp="vncfo1fjcg1">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-220" data-mp="5tx9k46psn4a">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-221" data-mp="au32dnoq0fny">
          <div data-id="element-222" data-mp="aryqaigo4acl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-teal" data-id="element-223" data-mp="as8dxze8q5f4">
              Why neighbors call back
            </p>
            <h2 className="mt-3 font-display text-3xl leading-tight tracking-tight text-brand-navy sm:text-4xl lg:text-5xl" data-id="element-224" data-mp="2cmhkamr9lk4d">
              THE HOMETOWN DIFFERENCE.
            </h2>
            <p className="mt-4 text-lg text-brand-navy/70" data-id="element-225" data-mp="3jxfa06k6fx76">
              Bucket Hat Cleaning is a small Lincoln operation, and that is the
              whole point. The person who quotes your house is the person who
              cleans it.
            </p>
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/f2d5e678-e23c-4298-9090-e10603e1c3a5.jpg" alt="A freshly cleaned Lincoln home with spotless windows and siding" className="mt-8 hidden h-72 w-full rounded-3xl object-cover shadow-lg lg:block" data-id="element-226" data-mp="3switvcr64gmq" />
          </div>

          <ul className="grid gap-5 sm:grid-cols-2" data-id="element-227" data-mp="ghqdhrpypyl3">
            {reasons.map(reason => <li key={reason.title} className="rounded-2xl bg-white p-6 ring-1 ring-brand-navy/10" data-id="element-228" data-mp="bhlsppi0uhp2">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-blue/10 text-brand-blue" data-id="element-229" data-mp="pi6canvrghjm">
                  <reason.icon className="h-6 w-6" aria-hidden="true" data-id="element-230" data-mp="kgz44npphgcf" />
                </span>
                <h3 className="mt-4 text-base font-bold text-brand-navy" data-id="element-231" data-mp="142sl03h1cxk8">
                  {reason.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-brand-navy/70" data-id="element-232" data-mp="v4gltd23srg6">
                  {reason.body}
                </p>
              </li>)}
          </ul>
        </div>

        <ol className="mt-16 grid gap-6 border-t border-brand-navy/10 pt-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-233" data-mp="ledvxlqa3tm2">
          {steps.map(step => <li key={step.step} data-id="element-234" data-mp="q5m4kfjsbay6">
              <span className="font-display text-4xl text-brand-blue/30" data-id="element-235" data-mp="q6nhkpkd27ij">
                {step.step}
              </span>
              <h3 className="mt-2 font-display text-lg tracking-tight text-brand-navy" data-id="element-236" data-mp="gerh57usy5b5">
                {step.title.toUpperCase()}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-navy/70" data-id="element-237" data-mp="2frsw1b7bsfi">
                {step.body}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}